import { useQuery } from "@tanstack/react-query";

import { categoriesApi } from "../api";
import type { CategoryItem } from "../api";
import { templateKeys } from "./template.keys";

export function useCategories() {
  const query = useQuery<CategoryItem[], Error>({
    queryKey: templateKeys.categories(),
    queryFn: ({ signal }) => categoriesApi.list({ limit: 200 }, signal),
    staleTime: 60_000,
  });

  return {
    categories: query.data ?? [],
    isLoading: query.isLoading,
    error: query.error,
  };
}
